import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

import { App } from './App';
import { captureReferral } from './lib/share';
import { SessionProvider } from './lib/session';
import { cssVariablesResolver, theme } from './theme';

// Retry is off. Every failure here is either a refusal the screen should show
// at once — a wrong PIN, a plan that has run out — or a model call that costs
// money, and silently making it three times is the wrong default for both.
const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

// Before anything routes: an invitation's ?ref= survives the sign-in and the
// mailed confirmation link, which is the long way round to founding a family.
captureReferral();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver} defaultColorScheme="light">
      <Notifications position="top-center" />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <SessionProvider>
            <App />
          </SessionProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
